import "core-js/modules/es.json.parse.js";
import { isBlob, isEmpty, isObject, isString, walkArray } from "@utils/commonUtil";
export class Response {
  constructor(code, status, message, data, origin) {
    this.code = code;
    this.status = status;
    this.message = message;
    this.data = data;
    this.origin = origin;
  }
  setMessage(msg) {
    this.message = msg;
    return this;
  }
  setData(data) {
    this.data = data;
    return this;
  }
}
class ResponseHelper {
  constructor(errorArray) {
    this.errorArray = [];
    this.errorArray = errorArray;
  }
  getMessage(res) {
    let msg = res.message;
    const code = this.getCode(res);
    walkArray(this.errorArray, function (item) {
      if (item.code == code) {
        msg = item.necessary ? item.msg : msg || item.msg;
        return true;
      }
    });
    return msg || "请求出错";
  }
  getCode(res) {
    return res.status ? res.status : res.code;
  }
  getData(response) {
    let data = response.data;
    if (isString(data) && data) {
      try {
        response.data = JSON.parse(data);
      } catch (error) {
        console.error(error);
      }
    }
    if (isEmpty(data)) {
      data = {};
    }
    return data;
  }
  isSuccess(res) {
    return this.getCode(res) === 200;
  }
  getResponse(response) {
    if (isBlob(response.data) || isString(response.data)) {
      console.log(typeof response.data);
      const code = 200;
      const data = response.data;
      const status = true;
      const message = "导出成功";
      return new Response(code, status, message, data, response);
    } else {
      const res = this.getResponseData(response);
      let status = false;
      const code = this.getCode(res);
      const data = this.getData(res);
      const message = this.getMessage(res);
      if (this.isSuccess(res)) {
        status = true;
      } else {
        status = false;
      }
      return new Response(code, status, message, data, response);
    }
  }
  getResponseData(res) {
    return res.data;
  }
  getResponseFromError(error) {
    if (isObject(error)) {
      let status = false;
      const code = error.status ? error.status : error.code;
      const data = this.getData(error);
      const message = this.getMessage(error);
      if (this.isSuccess(error)) {
        status = true;
      } else {
        status = false;
      }
      return new Response(code, status, message, data, error);
    } else {
      return new Response(500, false, error, {}, error);
    }
  }
}
export default ResponseHelper;